import React, { useEffect, useState } from 'react'
import {  DropDown } from '../../../commons';
import { contactTypeDropDown, entityDropDown } from '../../../../constant/clientDirectoryDropDown';
import { InputDetailsErrorType } from '..';
import Select from "react-select";
import { SelctOptionType } from '../../../DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm';
import { LoginResponseType } from '../../../../redux/auth/authTypes';


type AppProps = {
    isEdit: boolean;
    basicDetails: any;
    handleEntityChange: any;
    handleContactTypeChange: any;
    inputDetailsError: InputDetailsErrorType;
    setInputDetailsError: (data: any) => void;
    setClientBasicDetails: (data: any) => void
    isDisabled?:boolean
    clientCategory:SelctOptionType[]|[];
    finalCategoryList:any;
    handleClientCategoryChange:any;
    setCategoryOffset:React.Dispatch<React.SetStateAction<number>>;
    setCategoryText:React.Dispatch<React.SetStateAction<string>>
    loginData:LoginResponseType;
    fetching:boolean
    categoryLimit:number;

}

const BasicDetails = ({
    isEdit,
    basicDetails,
    handleEntityChange,
    handleContactTypeChange,
    setClientBasicDetails,
    inputDetailsError,
    setInputDetailsError,
    isDisabled,
    clientCategory,
    finalCategoryList,
    handleClientCategoryChange,
    setCategoryOffset,
    setCategoryText,
    loginData,
    fetching,
    categoryLimit

}: AppProps) => {
    const [accessToOthersText, setAccessToOthersText] = useState<string>("");
    const checkBottom = (e: any) => {
        setCategoryOffset((prv: any) => prv + categoryLimit);
    };


    useEffect(()=>{
        if(basicDetails?.lastName||basicDetails?.lastName){
            setInputDetailsError((prev: any) => {
                return {
                    ...prev,
                    companyNameError: ""
                }
            })
        }
    },[basicDetails?.entity?.value])

    useEffect(()=>{
        if(basicDetails?.lastName||basicDetails?.lastName){
            setClientBasicDetails((prev: any) => {
                return {
                    ...prev,
                    basicDetails: {
                        ...prev.basicDetails,
                        name: `${basicDetails?.lastName}${basicDetails?.lastName&&basicDetails?.firstName?", ":""}${basicDetails?.firstName}`
                    }
                }
            })
            setInputDetailsError((prev: any) => {
                return {
                    ...prev,
                    companyNameError: ""
                }
            })
        }
    },[basicDetails?.firstName,basicDetails?.lastName])
    const handleBasicDetailsInput = (data: any) => {
        setClientBasicDetails((prev: any) => {
            return {
                ...prev,
                basicDetails: {
                    ...prev.basicDetails,
                    [data.target.name]: data.target.value
                }
            }
        })
        if (data.target.name === "firstName") {
            if (data.target.value) {
                setInputDetailsError((prev: any) => {
                    return {
                        ...prev,
                        firstNameError: ""
                    }
                })
                if (basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship") {
                    setInputDetailsError((prev: any) => {
                        return {
                            ...prev,
                            companyNameError: ""
                        }
                    })
                }
            }
        }
        if ((basicDetails?.firstName||basicDetails?.lastName) && (basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship")) {
            setInputDetailsError((prev: any) => {
                return {
                    ...prev,
                    companyNameError: ""
                }
            })
        }
        if (data.target.name === "name") {
            if (data.target.value) {
                setInputDetailsError((prev: any) => {
                    return {
                        ...prev,
                        companyNameError: ""
                    }
                })
            }
        }
    }
    return (
        <>
            <div className='row'>
                <div className="col-md-3">
                    <label htmlFor="entity">Entity<span className='color-red'>*</span></label>
                    <div >
                        <DropDown
                            options={entityDropDown}
                            value={basicDetails?.entity}
                            handleChange={handleEntityChange}
                            extraClasses={`${inputDetailsError?.entityError ? "error-border rounded" : ""}`}
                            style={`${inputDetailsError?.entityError ? { border: "none" } : ""}`}
                            disabled={isDisabled}
                        />
                        {!!inputDetailsError?.entityError && (
                            <small className="text-danger">{inputDetailsError?.entityError}</small>
                        )}
                    </div>
                </div>
                {((isEdit && (basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship")) || (!isEdit && (basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship" || basicDetails?.entity?.value === ""))) && <>
                    <div className="col-md-3">
                        <label htmlFor="firstName">First Name<span className='color-red'>*</span></label>
                        <div >
                            <input
                                type="text"
                                className={`form-control ${inputDetailsError?.firstNameError ? "error-border" : ""}`}
                                name="firstName"
                                onChange={(e) => handleBasicDetailsInput(e)}
                                value={basicDetails?.firstName}
                                disabled={isDisabled}
                            />
                            {!!inputDetailsError?.firstNameError && (
                                <small className="text-danger">{inputDetailsError?.firstNameError}</small>
                            )}
                        </div>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="lastName">Last Name</label>
                        <div >
                            <input
                                type="text"
                                className="form-control"
                                name="lastName"
                                onChange={handleBasicDetailsInput}
                                value={basicDetails?.lastName}
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                </>}
                <div className="col-md-3">
                    <label htmlFor="name">Name<span className='color-red'>*</span></label>
                    <div >
                        <input
                            type="text"
                            className={`form-control ${inputDetailsError?.companyNameError ? "error-border" : ""}`}
                            name="name"
                            onChange={handleBasicDetailsInput}
                            disabled={basicDetails?.entity?.value == "" || basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship"||isDisabled}
                            value={(basicDetails?.entity?.value == "" || basicDetails?.entity?.value === "Individual" || basicDetails?.entity?.value === "Sole Proprietorship") ? `${basicDetails?.lastName}${(basicDetails?.lastName&&basicDetails?.firstName)?", ":""}${basicDetails?.firstName}` : basicDetails?.name}
                        />
                        {!!inputDetailsError?.companyNameError && (
                            <small className="text-danger">{inputDetailsError?.companyNameError}</small>
                        )}
                    </div>
                </div>
                {isEdit && <div className="col-md-3">
                    <label htmlFor="code">Code</label>
                    <div >
                        <input
                            type="text"
                            className="form-control"
                            name="code"
                            value={basicDetails?.code}
                             disabled={true}
                        />
                    </div>
                </div>}
            </div>
            <div className='row'>
                <div className="col-md-3 mt-3">
                    <label htmlFor="contactType">Contact Type</label>
                    <div >
                        <DropDown
                            options={contactTypeDropDown}
                            value={basicDetails?.contactType}
                            handleChange={handleContactTypeChange}
                         disabled={isDisabled}
                        />
                    </div>
                </div>
                <div className="col-md-3 mt-3">
                    <label htmlFor="mailingName">Mailing Name</label>
                    <div >
                        <input
                            type="text"
                            className="form-control"
                            name="mailingName"
                             disabled={isDisabled}
                            onChange={handleBasicDetailsInput}
                            value={basicDetails?.mailingName}
                        />
                    </div>
                </div>
                <div className="col-md-3 mt-3">
                    <label htmlFor="salutation">Salutation</label>
                    <div >
                        <input
                            type="text"
                            className="form-control"
                            name="salutation"
                            onChange={handleBasicDetailsInput}
                            value={basicDetails?.salutation}
                             disabled={isDisabled}
                        />
                    </div>
                </div>
                    <div className='col-md-3 mt-3'>
                    <label>
                    Client Category
                    </label>
                    <Select
                        className="dropdown"
                        placeholder={<div style={{color:"hsl(0, 0%, 20%)"}}>Select..</div>} 
                        value={clientCategory[0]?.label ? clientCategory?.filter((e: any) => e?.value !== loginData?.user_id) : []}
                        options={finalCategoryList}
                        onChange={handleClientCategoryChange}
                        isMulti
                        isClearable
                        isLoading={fetching && accessToOthersText?.length > 0}
                        isSearchable={true}
                        onMenuScrollToBottom={(e: any) => checkBottom(e)}
                        onInputChange={(e: string) => {
                            setCategoryText(e);
                            setAccessToOthersText(e);
                            setCategoryOffset(0);
                        }}
                        isDisabled={isDisabled}

                    />
                </div>

            </div>
        </>
    )
}

export default BasicDetails